import React from 'react'
import PropTypes from 'prop-types'
import { View } from '@react-pdf/renderer'

import { Status } from '@generators/pdfComponents/Status'
import { Box } from '@generators/pdfComponents/Box'
import { TresholdDisplay } from '@generators/pdfComponents/ThresholdDisplay'
import { getBloodPressureTresholdValue } from '@util/tresholdUtil'
import { statusColors } from '@generators/tresholdConstants'

export const BloodPressureStatus = ({ syst, diast, type }) => {
  const category = getBloodPressureTresholdValue(syst, diast)

  return (
    <View
      style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
    >
      <View>
        <Status
          text={category}
          backgroundColor={`${statusColors[category]}1A`}
          textColor={statusColors[category]}
          style={{ marginRight: 24 }}
        />
      </View>
      <Box width={223.5}>
        <TresholdDisplay syst={syst} diast={diast} type={type} />
      </Box>
    </View>
  )
}

BloodPressureStatus.propTypes = {
  syst: PropTypes.number.isRequired,
  diast: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
}
